import { enumConvert } from '../../helpers/enumConvert';
import { StrategyTypeBase } from '../Base/StrategyType';

export const StrategyType = enumConvert(StrategyTypeBase);
